import { z } from 'zod';
import { promotionCodeSchema } from './promotion';

export const upgradeSubscriptionSchema = z.object({
  // CENTER joined the enum with pricing v2 (THI-134): it carries a real
  // priceVnd now, and POST /subscription/upgrade was never plan-specific —
  // amounts come off the plan row — so this widening is the whole change.
  planCode: z.enum(['PLUS', 'PRO', 'CENTER']),
  billingCycle: z.enum(['MONTHLY', 'ANNUAL']).default('MONTHLY'),
  // THI-200: reuses promotionCodeSchema so the wire arrives already
  // trimmed and uppercased — the route never re-normalizes it.
  promoCode: promotionCodeSchema.optional(),
});

export type UpgradeSubscriptionInput = z.infer<typeof upgradeSubscriptionSchema>;
